export default __webpack_public_path__ + "static/media/placeholder_business05-nl-mobile.61f8fecb.png";